<hr class="upperline" />
<div class="my-account-form-container terra-error-style" [formGroup]="formGroup" [class.loading-container-overlay]="isLoading">

  <div class="form-grid">

    <p class="full-width">
      Add an extra layer of security to your account.<br />
      We'll send a verification code to your phone each time you log in from a new device.
    </p>

    Enable Two-factor Authentication
    <mat-slide-toggle hideIcon labelPosition="before" formControlName="twoFactorEnabled"></mat-slide-toggle>

    <!-- phone -->
    <div *ngIf="showPhoneField">

      <!-- Phone number -->
      <terra-phone formControlName="phone" *ngIf="!waitingForCode">
        <label for="txtPhone" class="text-input-label">Phone</label>
        <mat-error *ngIf="formGroup.get('phone').hasError('required')">Required</mat-error>
      </terra-phone>

      <button mat-flat-button color="accent" class="page-cta half-width tall-button" (click)="sendSmsVerification()" *ngIf="!waitingForCode">
        Send Verification Code
      </button>

      <p *ngIf="waitingForCode">
        Please enter the verification code we sent to <span class="lo_sensitive">{{ phone }}</span>
      </p>

      <div class="terra-form-field-wrapper full-width" *ngIf="waitingForCode">
        <label for="txtVerificationCode" class="text-input-label">Verification Code</label>
        <mat-form-field appearance="outline" class="half-width">
          <input matInput id="txtVerificationCode" formControlName="verificationCode" maxlength="6" required class="lo_sensitive" />

          <mat-error *ngIf="formGroup.get('verificationCode').hasError('code')">
            Wrong code, please try again.
          </mat-error>
          <mat-error *ngIf="formGroup.get('verificationCode').hasError('expired')">
            Code is expired, code is valid for 10 minutes. Please try to resend the code.
          </mat-error>
          <mat-error *ngIf="formGroup.get('verificationCode').hasError('general')">
            An error has occurred. Please try again, and if no luck, contact support.
          </mat-error>

        </mat-form-field>
      </div>

      <button mat-flat-button color="accent" class="page-cta half-width tall-button" (click)="smsVerify()" *ngIf="waitingForCode">
        Submit
      </button>

      <p *ngIf="waitingForCode">
        Didn’t receive a code?
        <a class="link" (click)="resendCode()">Resend code</a>
      </p>

    </div>

    <terra-loader class="full-width" *ngIf="isLoading" centerToParent="true"></terra-loader>

    <div class="form-actions full-width">
    </div>

  </div>
</div>
